import { Component } from '@angular/core';

@Component({
  selector: 'app-demandas-monitoramento-cadastro',
  templateUrl: './demandas-monitoramento-cadastro.component.html',
  styleUrls: ['./demandas-monitoramento-cadastro.component.scss']
})
export class DemandasMonitoramentoCadastroComponent {

}
